// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__36E_d","search":"Settings_search__aMSdX","filter":"Settings_filter__1zaX6"};